import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Rehan Khalil`}</h1>
    <p>{`I am Enthusiastic and a Passionate Web Developer. I love building Web Apps and continuously improving my skillsets. And I am an Open Source Contributer too.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      